import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface InboxUIState {
  /** `null` until the user picks a mode; the viewport decides until then. */
  isMobileView: boolean | null;
  setIsMobileView: (isMobileView: boolean) => void;
  /** Opt-in: send this device to the Inbox when the app opens with no destination. */
  isInboxHome: boolean;
  setIsInboxHome: (isInboxHome: boolean) => void;
}

export const useInboxUIStore = create<InboxUIState>()(
  persist(
    (set) => ({
      isMobileView: null,
      setIsMobileView: (isMobileView) => set({ isMobileView }),
      isInboxHome: false,
      setIsInboxHome: (isInboxHome) => set({ isInboxHome }),
    }),
    {
      name: 'aofh-inbox-ui',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
